import { Component, OnInit } from "@angular/core";
import { AuthService } from "../auth.service";
import { ToastrService } from "ngx-toastr";
import { NgxSpinnerService } from "ngx-spinner";
import { Router } from "@angular/router";
import * as CryptoJS from "crypto-js";
import { environment } from "src/environments/environment";
import * as moment from "moment";
import { DateAdapter } from "@angular/material/core";
import firebase from "firebase";
import FingerprintJS from "@fingerprintjs/fingerprintjs";

@Component({
  selector: "app-personal-information",
  templateUrl: "./personal-information.component.html",
  styleUrls: ["./personal-information.component.css"],
})
export class PersonalInformationComponent implements OnInit {
  model: any = {};
  passwordType: any = "password";
  confirmPasswordType: any = "password";
  encryptedData: string;
  userInfo: any;
  showEmail: boolean;
  minDate = moment().subtract(100, "years").format("YYYY-MM-DD");
  maxDate = moment().subtract(18, "years").format("YYYY-MM-DD");
  oneSignalData: any = {};
  deviceId: any;
  constructor(
    private signUpService: AuthService,

    private spinner: NgxSpinnerService,
    private toastr: ToastrService,
    private router: Router,
    private dateAdapter: DateAdapter<Date>
  ) {
    this.dateAdapter.setLocale("en-GB");
    const token = localStorage.getItem("signup_second");
    if (localStorage.getItem(environment.localStorageKey)) {
      this.encryptedData = localStorage.getItem(environment.localStorageKey);
      this.userInfo = JSON.parse(
        CryptoJS.AES.decrypt(
          this.encryptedData,
          environment.secretkey
        ).toString(CryptoJS.enc.Utf8)
      );
      if (this.userInfo.results.subscription_type == null) {
        this.router.navigate(["/home/subscription"]);
      } else {
        this.router.navigate(["/pages/landing"]);
      }
    } else if (token == null || token == "signup_second") {
      this.router.navigate(["/"]);
    }
  }

  async ngOnInit() {
    const data = JSON.parse(
      CryptoJS.AES.decrypt(
        localStorage.getItem("signup_first"),
        environment.secretkey
      ).toString(CryptoJS.enc.Utf8)
    );

    if (data.type == "email") {
      if (!this.model.email) {
        this.model.email = data.email;
      }
      this.showEmail = true;
    } else {
      this.showEmail = false;
    }
    // this.titleService.setTitle("signup");
    const fp = await FingerprintJS.load();
    const result = await fp.get();
    this.deviceId = result.visitorId;
  }

  signup(form) {
    if (form) {
      const encryptedData = localStorage.getItem("oneSignalData");
      if (encryptedData) {
        this.oneSignalData = JSON.parse(
          CryptoJS.AES.decrypt(encryptedData, environment.secretkey).toString(
            CryptoJS.enc.Utf8
          )
        );
      }

      this.model.one_signal_id = this.oneSignalData.id;
      this.model.device_id = this.deviceId;
      const token = localStorage.getItem("signup_second");
      this.model.verify_token = token;
      this.spinner.show();
      this.signUpService.signUpCompleted(this.model).subscribe(
        (data) => {
          if (data) {
            if (environment.analyticsStatus) {
              const analytics = firebase.analytics();
              analytics.logEvent("signup");
            }
            this.spinner.hide();

            const user_data = data.results;
            user_data.people_profile = data.people_profile.results;
            user_data.profile_id = data.people_profile.results[0].id;
            const app_promo = CryptoJS.AES.encrypt(
              JSON.stringify(user_data),
              environment.secretkey
            ).toString();
            localStorage.setItem(environment.localStorageKey, app_promo);
            localStorage.setItem("user_info", app_promo);
            this.toastr.success(data.message, "Success!", {
              closeButton: true,
            });
            this.router.navigate(["/subscription"]);
            localStorage.removeItem("signup_second");
            localStorage.removeItem("signup_first");
          }
        },
        (err) => {
          if (err.status === 0) {
            this.spinner.hide();
            this.toastr.error("CONNECTION REFUSED", "OOPS!", {
              closeButton: true,
            });
          } else if (err.status === 500) {
            this.spinner.hide();
            this.toastr.error(err.datas.message, "OOPS!", {
              closeButton: true,
            });
          } else if (err.status === 404) {
            this.spinner.hide();
            this.toastr.error(err.datas.message, "OOPS!", {
              closeButton: true,
            });
          } else if (err.status === 401) {
            this.spinner.hide();
            this.toastr.error(err.datas.message, "OOPS!", {
              closeButton: true,
            });
          } else {
            this.spinner.hide();
            this.toastr.error(err.datas.message, "OOPS!", {
              closeButton: true,
            });
          }
        }
      );
    }
  }

  changePasswordType(type: any): void {
    if (type === "password") {
      if (this.passwordType === "password") {
        this.passwordType = "text";
      } else {
        this.passwordType = "password";
      }
    } else if (type === "confirmPassword") {
      if (this.confirmPasswordType === "password") {
        this.confirmPasswordType = "text";
      } else {
        this.confirmPasswordType = "password";
      }
    }
  }
}
